<template>
  <div class="completed-orders-page">
    <div class="header-row">
      <div>
        <h2>订购明细</h2>
        <p>仅查看审核已完成订单，按产品明细展示和导出。</p>
      </div>
      <el-button v-if="canExport" plain @click="openExportDialog">导出当前结果</el-button>
    </div>

    <div class="brand-card filter-card">
      <div class="filter-card__header"><strong>查询条件</strong></div>
      <div class="toolbar-row">
        <el-input v-model="filters.order_no" placeholder="订单号（精确）" clearable />
        <el-input v-model="filters.keyword" placeholder="收件人 / 上游单号" clearable />
        <el-input v-model="filters.recipient_phone" placeholder="收件人电话（精确）" clearable />
        <el-select v-model="filters.business_type" placeholder="业务类型" clearable filterable>
          <el-option v-for="item in businessTypeOptions" :key="item.id" :label="item.name" :value="item.name" />
        </el-select>
        <el-input v-model="filters.new_phone" placeholder="新开号码" clearable />
        <el-input v-model="filters.team_name" placeholder="归属团队" clearable />
        <el-select v-model="filters.courier_id" placeholder="配送员" clearable filterable>
          <el-option v-for="courier in couriers" :key="courier.id" :label="courier.name" :value="courier.id" />
        </el-select>
        <el-input v-model="filters.address_keyword" placeholder="收件地址（模糊）" clearable />
        <el-select v-model="filters.source" placeholder="建单来源" clearable filterable>
          <el-option v-for="item in orderSourceOptions" :key="item.id" :label="displayOrderSource(item.name)" :value="item.name" />
        </el-select>
        <el-select v-model="filters.is_urgent" placeholder="是否加急" clearable>
          <el-option label="加急" :value="true" /><el-option label="非加急" :value="false" />
        </el-select>
        <el-select v-model="filters.is_published" placeholder="是否发布" clearable>
          <el-option label="已发布" :value="true" /><el-option label="未发布" :value="false" />
        </el-select>
        <el-select v-if="canFilterManager" v-model="filters.manager_id" placeholder="归属管理员" clearable filterable>
          <el-option v-for="leader in leaders" :key="leader.id" :label="leader.name" :value="leader.id" />
        </el-select>
        <el-date-picker v-model="filters.dateRange" type="daterange" range-separator="至" start-placeholder="创建开始日期" end-placeholder="创建结束日期" value-format="yyyy-MM-dd" />
        <el-button type="primary" plain @click="handleQuery">查询</el-button>
      </div>
    </div>

    <div class="brand-card table-card">
      <div class="table-scroll">
        <el-table :data="items" :height="680" stripe>
          <el-table-column prop="order_no" label="配送单号" min-width="160" />
          <el-table-column prop="upstream_order_no" label="上游单号" min-width="140" />
          <el-table-column prop="team_name" label="归属团队" min-width="120" />
          <el-table-column prop="created_by_name" label="建单人" min-width="110" />
          <el-table-column prop="sales_name" label="归属业务员" min-width="120" />
          <el-table-column prop="manager_name" label="归属管理员" min-width="120" />
          <el-table-column prop="business_type" label="业务类型" min-width="120" />
          <el-table-column prop="product_name" label="产品名称" min-width="140" />
          <el-table-column prop="recipient_phone" label="联系号码" min-width="150" />
          <el-table-column prop="submitted_review_at" label="配送完成时间" min-width="180" />
          <el-table-column label="是否新开户" width="110"><template slot-scope="{ row }">{{ row.is_new_account ? "是" : "否" }}</template></el-table-column>
          <el-table-column prop="new_phone" label="新开号码" min-width="150" />
          <el-table-column prop="first_recharge_amount" label="首充金额" width="110" />
          <el-table-column prop="product_remark" label="产品备注" min-width="160" />
          <el-table-column prop="courier_name" label="归属配送员" min-width="120" />
          <el-table-column prop="full_address" label="收件地址" min-width="260" />
          <el-table-column prop="recipient_name" label="收件人" width="100" />
          <el-table-column prop="id_card_no" label="收件人身份证号码" min-width="190" />
          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="{ row }"><el-button size="mini" type="info" plain @click="goDetail(row)">详情</el-button></template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager-row">
        <el-pagination background layout="total, prev, pager, next, sizes" :total="total" :page-size="pager.page_size" :current-page="pager.page" :page-sizes="[10, 20, 50]" @current-change="onPageChange" @size-change="onSizeChange" />
      </div>
    </div>

    <el-dialog title="选择导出字段" :visible.sync="showExportFields" width="760px">
      <div class="export-field-toolbar">
        <span>默认导出全部字段，可取消不需要的字段。</span>
        <span><el-button type="text" @click="selectAllExportFields">全选</el-button><el-button type="text" @click="clearExportFields">清空</el-button></span>
      </div>
      <el-checkbox-group v-model="selectedExportFields" class="export-field-grid">
        <el-checkbox v-for="item in exportFieldOptions" :key="item.key" :label="item.key">{{ item.label }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer"><el-button @click="showExportFields = false">取消</el-button><el-button type="primary" @click="confirmExport">确认导出</el-button></span>
    </el-dialog>

    <el-dialog title="选择导出方式" :visible.sync="showExportSecurity" width="460px" :close-on-click-modal="false">
      <el-radio-group v-model="exportSensitiveMode" class="export-mode-options">
        <el-radio label="masked">脱敏导出（无需验证码）</el-radio>
        <el-radio label="unmasked">不脱敏导出（需短信验证码）</el-radio>
      </el-radio-group>
      <div v-if="exportSensitiveMode === 'unmasked'" class="sms-verify-row">
        <p>验证码将发送到当前登录账号绑定手机号（尾号 {{ exportPhoneLast4 || '----' }}）。</p>
        <el-input v-model="exportSmsCode" maxlength="6" placeholder="请输入短信验证码" />
        <el-button :loading="exportSmsSending" @click="sendExportSmsCode">发送验证码</el-button>
      </div>
      <span slot="footer"><el-button @click="showExportSecurity = false">取消</el-button><el-button type="primary" :loading="exporting" @click="submitExport">确认导出</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { exportCompletedOrderProducts, fetchBusinessTypes, fetchCompletedOrderProducts, fetchCouriers, fetchLeaders, fetchOrderSources, sendSensitiveExportSms, verifySensitiveExportSms } from "../api/orders";
import { getStoredUser, hasRole } from "../utils/auth";

const EXPORT_FIELD_OPTIONS = [
  { key: "order_no", label: "订单号" }, { key: "promotion_plan", label: "宣传方案" },
  { key: "product_name", label: "产品名称" }, { key: "recipient_name", label: "收件人" },
  { key: "recipient_phone", label: "联系电话" }, { key: "card_holder_name", label: "办卡人" },
  { key: "card_holder_phone", label: "办卡人手机号" }, { key: "id_card_no", label: "身份证号" },
  { key: "province_name", label: "省" }, { key: "city_name", label: "市" },
  { key: "district_name", label: "区县" }, { key: "street_name", label: "街道/乡镇" },
  { key: "street_no", label: "街道号码" }, { key: "detail_address", label: "详细地址" },
  { key: "full_address", label: "完整地址" }, { key: "business_type", label: "业务类型" },
  { key: "payment_type", label: "支付方式" }, { key: "is_urgent", label: "是否加急" },
  { key: "delivery_sms_enabled", label: "配送短信" }, { key: "is_published", label: "发布" },
  { key: "team_name", label: "归属团队" }, { key: "status", label: "状态" },
  { key: "expected_delivery_date", label: "期望配送时间" }, { key: "delivery_time_range", label: "配送时间段" },
  { key: "receivable_amount", label: "应收金额" }, { key: "actual_amount", label: "实收金额" },
  { key: "is_new_account", label: "是否新开户" }, { key: "new_phone", label: "新开号码" },
  { key: "first_recharge_amount", label: "首充金额" }, { key: "source", label: "建单来源" },
  { key: "upstream_order_no", label: "上游单号" }, { key: "upstream_app_name", label: "上游应用" },
  { key: "downstream_app_name", label: "下游应用" }, { key: "created_by_name", label: "建单人" },
  { key: "manager_name", label: "归属管理员" }, { key: "sales_name", label: "归属业务员" },
  { key: "courier_name", label: "归属配送员" }, { key: "grab_distance_meters", label: "抢单距离" },
  { key: "submitted_review_at", label: "提交待审核时间" }, { key: "completed_at", label: "完成时间" },
  { key: "failed_at", label: "失败时间" }, { key: "reschedule_time", label: "改约时间" },
  { key: "remark", label: "订单备注" }, { key: "reschedule_remark", label: "改约备注" },
  { key: "failure_remark", label: "失败原因" }, { key: "completion_remark", label: "完成备注" },
  { key: "custom_field1_label", label: "自定义字段1名称" }, { key: "custom_field1_value", label: "自定义字段1值" },
  { key: "custom_field2_label", label: "自定义字段2名称" }, { key: "custom_field2_value", label: "自定义字段2值" },
  { key: "created_at", label: "创建时间" }, { key: "updated_at", label: "更新时间" },
  { key: "product_remark", label: "产品备注" },
];

export default {
  data() {
    return {
      currentUser: getStoredUser(), items: [], total: 0, pager: { page: 1, page_size: 10 },
      couriers: [], leaders: [], businessTypeOptions: [], orderSourceOptions: [],
      showExportFields: false, showExportSecurity: false, exportFieldOptions: EXPORT_FIELD_OPTIONS, selectedExportFields: EXPORT_FIELD_OPTIONS.map((item) => item.key),
      exportSensitiveMode: "masked", exportSmsCode: "", exportVerifyToken: "", exportPhoneLast4: "", exportSmsSending: false, exporting: false,
      filters: { order_no: "", keyword: "", recipient_phone: "", business_type: "", new_phone: "", team_name: "", courier_id: "", address_keyword: "", source: "", is_urgent: "", is_published: "", manager_id: "", dateRange: [] },
    };
  },
  computed: {
    canExport() { return hasRole(this.currentUser, ["super_admin", "admin"]); },
    canFilterManager() { return hasRole(this.currentUser, ["super_admin", "admin"]); },
  },
  mounted() { this.loadData(); this.loadOptions(); },
  methods: {
    displayOrderSource(source) { return source === "manual" ? "手工录入" : source || "-"; },
    buildParams() {
      return { order_no: this.filters.order_no || undefined, keyword: this.filters.keyword || undefined, recipient_phone: this.filters.recipient_phone || undefined, business_type: this.filters.business_type || undefined, new_phone: this.filters.new_phone || undefined, team_name: this.filters.team_name || undefined, courier_id: this.filters.courier_id || undefined, address_keyword: this.filters.address_keyword || undefined, source: this.filters.source || undefined, is_urgent: this.filters.is_urgent === "" ? undefined : this.filters.is_urgent, is_published: this.filters.is_published === "" ? undefined : this.filters.is_published, manager_id: this.filters.manager_id || undefined, created_start: this.filters.dateRange[0], created_end: this.filters.dateRange[1] };
    },
    async loadData() {
      const { data } = await fetchCompletedOrderProducts({ ...this.buildParams(), page: this.pager.page, page_size: this.pager.page_size });
      this.items = data.items || []; this.total = data.total || 0;
    },
    async loadOptions() {
      const requests = [fetchBusinessTypes({ page: 1, page_size: 1000, is_active: true }), fetchOrderSources({ page: 1, page_size: 1000, is_active: true })];
      if (this.canFilterManager) requests.push(fetchCouriers(), fetchLeaders());
      const results = await Promise.all(requests);
      this.businessTypeOptions = results[0].data.items || []; this.orderSourceOptions = results[1].data.items || [];
      if (this.canFilterManager) { this.couriers = results[2].data || []; this.leaders = results[3].data || []; }
    },
    handleQuery() { this.pager.page = 1; this.loadData(); },
    onPageChange(page) { this.pager.page = page; this.loadData(); },
    onSizeChange(size) { this.pager.page_size = size; this.pager.page = 1; this.loadData(); },
    goDetail(row) { this.$router.push(`/orders/${row.order_id}`); },
    openExportDialog() { this.selectedExportFields = this.exportFieldOptions.map((item) => item.key); this.showExportFields = true; },
    selectAllExportFields() { this.selectedExportFields = this.exportFieldOptions.map((item) => item.key); },
    clearExportFields() { this.selectedExportFields = []; },
    async confirmExport() {
      if (!this.selectedExportFields.length) { this.$message.warning("请至少选择一个导出字段"); return; }
      this.exportSensitiveMode = "masked"; this.exportSmsCode = ""; this.exportVerifyToken = ""; this.exportPhoneLast4 = "";
      this.showExportFields = false; this.showExportSecurity = true;
    },
    async sendExportSmsCode() {
      this.exportSmsSending = true;
      try {
        const { data } = await sendSensitiveExportSms();
        this.exportVerifyToken = data.verify_token; this.exportPhoneLast4 = data.phone_last4 || "";
        this.$message.success("验证码已发送");
      } finally { this.exportSmsSending = false; }
    },
    async submitExport() {
      let sensitiveExportToken = "";
      if (this.exportSensitiveMode === "unmasked") {
        if (!this.exportVerifyToken) { this.$message.warning("请先发送短信验证码"); return; }
        if (!this.exportSmsCode) { this.$message.warning("请输入短信验证码"); return; }
        const { data } = await verifySensitiveExportSms({ verify_token: this.exportVerifyToken, sms_code: this.exportSmsCode });
        sensitiveExportToken = data.sensitive_export_token;
      }
      this.exporting = true;
      try {
        const { data } = await exportCompletedOrderProducts({ ...this.buildParams(), fields: this.selectedExportFields.join(",") }, sensitiveExportToken);
      const blob = new Blob([data], { type: "text/csv;charset=utf-8;" }); const link = document.createElement("a");
      link.href = URL.createObjectURL(blob); link.download = "订购明细导出.csv"; link.click(); URL.revokeObjectURL(link.href);
        this.showExportSecurity = false;
      } finally { this.exporting = false; }
    },
  },
};
</script>

<style scoped>
.header-row { display: flex; justify-content: space-between; align-items: center; gap: 16px; margin-bottom: 18px; }
.header-row h2 { margin: 0 0 8px; }.header-row p { margin: 0; color: #60718f; }
.filter-card { margin-bottom: 18px; }.filter-card__header { margin-bottom: 14px; }.toolbar-row { display: flex; flex-wrap: wrap; gap: 10px; }.toolbar-row > * { width: 190px; }.table-scroll { width: 100%; overflow: hidden; }.table-scroll :deep(.el-table__body-wrapper) { overflow: auto !important; }.pager-row { display: flex; justify-content: flex-end; margin-top: 16px; }
.export-field-toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; color: #5f7498; }.export-field-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px 14px; max-height: 420px; overflow: auto; }.export-field-grid :deep(.el-checkbox) { margin-right: 0; }
.export-mode-options { display: flex; flex-direction: column; gap: 14px; }.sms-verify-row { display: grid; grid-template-columns: 1fr auto; gap: 10px; margin-top: 18px; }.sms-verify-row p { grid-column: 1 / -1; margin: 0; color: #5f7498; }
</style>
